import "@/App.css";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/LanguageContext";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { Gallery } from "@/components/Gallery";
import { HowItWorks } from "@/components/HowItWorks";
import { ServiceArea } from "@/components/ServiceArea";
import { Testimonials } from "@/components/Testimonials";
import { QuoteForm } from "@/components/QuoteForm";
import { Footer } from "@/components/Footer";
import { StickyBar } from "@/components/StickyBar";

function App() {
  return (
    <LanguageProvider>
      <div className="App bg-steel-950" data-testid="app-root">
        <Header />
        <main>
          <Hero />
          <Services />
          <Gallery />
          <HowItWorks />
          <ServiceArea />
          <Testimonials />
          <QuoteForm />
        </main>
        <Footer />
        <StickyBar />
        <Toaster theme="dark" position="top-center" />
      </div>
    </LanguageProvider>
  );
}

export default App;
